import { ActivatedRouteSnapshot } from '@angular/router';

import { ClientConfigProductName } from '@frontend/vanilla/core';

import { SamePathAppVersion } from '../app.version.enum';
import { allowedProductGuard, isSportsVersionMatch, matchAppVersionProductLoadGuard, productUnderMaintenanceGuard } from '../guards';
import { RoutesConfig } from './routes-config';

const routes: RoutesConfig = {
    routes: [
        {
            path: 'sports',
            loadChildren: () => import('@frontend/oxygen/cm-host-app').then((t) => t.CMHostAppModule),
            canMatch: [
                allowedProductGuard,
                (route: ActivatedRouteSnapshot) =>
                    matchAppVersionProductLoadGuard(ClientConfigProductName.SPORTS, SamePathAppVersion.CORAL_MOBILE_APP, route),
            ],
            canActivate: [
                (route: ActivatedRouteSnapshot) =>
                    productUnderMaintenanceGuard(route, ClientConfigProductName.SPORTS, SamePathAppVersion.CORAL_MOBILE_APP),
            ],
            data: {
                product: ClientConfigProductName.OZONE,
                canPreload: [isSportsVersionMatch(SamePathAppVersion.CORAL_MOBILE_APP), allowedProductGuard],
            },
        },
    ],
};

export default routes;
